export default __webpack_public_path__ + "static/media/roi.83d9d728.svg";